module.exports = {
  // 成员页
  JCRing_member: {
    //首页
    index1: "ชุมชนสุขภาพ",
    index2: "กลุ่มสุขภาพ",
    index3: "สมาชิก",
    index4: "สร้างกลุ่มใหม่",
    index5: "กลุ่มของฉัน",
    index6: "Alert Settings",
    index7: "ดูแลสุขภาพคนที่คุณรัก",
    index8: "ไม่มีกลุ่ม",
    index9: "สมาชิก",
    index10: "เชิญเพื่อเข้ากลุ่มผ่าน เบอร์โทร / อีเมล์ / CR Code / We Chat",

    //创建群组
    addgroup1: "ชื่อกลุ่มใหม่ ",
    addgroup2: "ประเภทกลุ่ม ",
    addgroup3: "กรุณากรอก",
    addgroup4: "กลุ่มครอบครัว",
    addgroup5: "กลุ่มเพื่อนร่วมงาน",
    addgroup6: "กลุ่มอื่นๆ",
    addgroup7: "กลุ่มโรงพยาบาล",
    addgroup8: "กลุ่มเพื่อนเรียน",
    addgroup9: "ใช่",
    addgroup10: "ไม่",
    addgroup11: "สร้างกลุ่มใหม่",
    addgroup12: "มีชื่อกลุ่มนี้อยู่แล้ว",

    //成员列表
    memberlist1: "รายการสมาชิก",
    memberlist2: "มี",
    memberlist3: "ความผิดปกติ",
    memberlist4: "ปกติ",
    memberlist5: "เพิ่มสมาชิก",
    memberlist6: "ลบ",
    memberlist7: "ไม่มีสมาชิก",
    memberlist8: "กำลังโหลด...",
    memberlist9: "แน่ใจที่จะออกจากกลุ่มนี้ใช่ไหม?",
    memberlist10: "ลบสำเร็จแล้ว",
    memberlist11: "บันทึกสำเร็จแล้ว",
    memberlist12: "แก้ไข",
    memberlist13: "ออกจากกลุ่ม",
    memberlist14: "สถานะสุขภาพ",
    memberlist15: "ปกติ",
    memberlist16: " ผิดปกติ",
    memberlist17: "ข้อมูลเพิ่มเติม",
    memberlist18: "ไม่มีข้อมูลเมื่อวานนี้",
    memberlist19: "เมื่อวาน",
    memberlist20: "คุณได้รับเชิญเข้ากลุ่ม",
    memberlist21: "ยืนยัน! เพื่อเข้ากลุ่ม xxx",

    //修改成员
    updatemember1: "ประวัติส่วนตัว",
    updatemember2: "เปลี่ยน",
    updatemember3: "ชื่อเล่นเก่า",
    updatemember4: "เปลี่ยนชื่อเล่น",

    //健康数据
    healthdata1: " สุขภาพ",
    healthdata2: "ข้อมูลสุขภาพ",
    healthdata3: "อา.",
    healthdata4: "จ.",
    healthdata5: "อ.",
    healthdata6: "พ",
    healthdata7: "พฤ",
    healthdata8: "ศ.",
    healthdata9: "ส.",
    healthdata10: "อัตราการเต้นของหัวใจ",
    healthdata11: "HRV",
    healthdata12: "Systolic ",
    healthdata13: "Diastolic ",
    healthdata14: "อุณหภูมิร่างกาย",
    healthdata15: "ออกซิเจนในเลือด",
    healthdata16: "การนอนหลับ",
    healthdata17: "ความเครียด",
    healthdata18: "คอเลสเตอรอล",
    healthdata19: "ไตรกลีเซอไรด์",
    healthdata20: "ไขมันเลว",
    healthdata21: "ไขมันดี",
    healthdata22: "น้ำตาลในเลือด",
    healthdata23: "ก่อนทานอาหาร ",
    healthdata24: "หลังทานอาหาร ",
    healthdata25: "VO2 Max",
    healthdata26: "การหายใจ",
    healthdata27: "นับก้าว",
    healthdata28: "ก้าว",
    healthdata29: "แคลอรี่",
    healthdata30: "kcal",
    healthdata31: "ระยะทาง",
    healthdata32: "กม.",
    healthdata33: "ความเร็ว",
    healthdata35: "″/กม.",
    healthdata36: "′",
    healthdata37: "กำลังสร้างรายการสุขภาพ",
    healthdata38: "ข้อมูลการเคลื่อนไหว",
    healthdata39: "เตือน",
    healthdata40: "ไม่ได้รับอนุญาต ",
    healthdata41: "แก้ไข",
    healthdata42: "ลบ",
    healthdata43: "อีเมล์: ",
    healthdata44: "โทรศัพท์: ",
    healthdata45: "ยืนยันที่จะลบ?",
    healthdata46: "ไม่สามารถแสดงข้อมูลวันที่ยังไม่ถึงได้",
    healthdata47: "วันนี้",


    //邀请成员
    addmember1: "เพิ่มสมาชิก",
    addmember2: "เพิ่ม ID",
    addmember4: "คุณสามารถดูข้อมูลสุขภาพของสมาชิกและตั้งค่าความผิดปกติของสมาชิกได้",
    addmember5: "Details",
    addmember6: "กลุ่มสมาชิก",
    addmember7: "เชิญ",
    addmember8: " เข้าร่วม",
    addmember9: "QR Code",
    addmember10: "WeChat",
    addmember11: "เชิญเข้ากลุ่มด้วยการสแกน QR code",
    addmember12: "เชิญเข้ากลุ่มผ่าน WeChat",
    addmember13: "โทรศัพท์/อีเมล์",
    addmember14: "เชิญเข้ากลุ่มผ่าน โทรศัพท์/อีเมล์",
    addmember15:
      "เชิญคนที่คุณรักเข้าร่วมกลุ่ม เพื่อใส่ใจสุขภาพของพวกเขาให้มากขึ้น.",
    addmember16: "เชิญเลย!!",
    addmember17: "ส่งเรียบร้อยแล้ว ",
    addmember18: "กำลังการยืนยัน",
    addmember19: "เข้าร่วมแล้ว",
    addmember20: "แชร์เลย",
    addmember21: "บันทึกรูป",
    addmember22: "ปฏิเสธ ",
    addmember23: "ออก",
    addmember24:  "ออกจากกลุ่มเรียบร้อยแล้ว",
    addmember25: "ไม่เข้าร่วม",
    addmember26: "เข้ากลุ่มเรียบร้อยแล้ว",
    addmember27: "วิธีการอื่นๆ", 


    // 群组二维码
    code1: "QR Code ของกลุ่ม",
    code2: "ชุมชนสุขภาพ",
    code3: "QR Code มีอายุ 5 นาที โปรดlสแกนทันที.",

    //群组邀请
    invide1: "การเชิญเข้ากลุ่ม",
    invide2: "ชุมชนสุขภาพ",
    invide3: "คุณได้รับเชิญเข้ากลุ่ม กรุณายืนยีน",
    invide4: "เข้าร่วมกลุ่มหรือไม่？",
    invide5:
      "เพื่อความปลอดภัยของข้อมูล กรุณาตรวจสอบข้อมูลของกลุ่มก่อนเข้าร่วม",
    invide6:
      "หลังจากเข้าร่วมกลุ่มแล้ว คุณสามารถเลือกให้สมาชิกคนใดคนหนึ่งดูข้อมูลสุขภาพของคุณได้",

    //分享健康数据设置
    sethealthdata1: "ตั้งค่าข้อมูลสุขภาพ",
    sethealthdata2: "ยืนยัน",
    sethealthdata3: "ไม่มีชื่อเล่น ",
    sethealthdata4: "อนุญาตทั้งหมด",
    sethealthdata5: "ชื่อเล่น ",
    sethealthdata6: "บันทึก",
    sethealthdata7: "กรอกข้อมูล",
    sethealthdata8: "กรุณาอัปโหลดรูปภาพ",
    sethealthdata9: "ไม่มีชื่อเล่น ",
    sethealthdata10: "ไม่มีรูปประจำตัว ",
    sethealthdata11: "ชื่อเล่นมีความยาวระหว่าง 1-8 ตัวอักษร",

    // 设置数据区间
    setscope1: "การเตือนหัวใจ",
    setscope2: "การเตือนอุณหภูมิร่างกาย",
    setscope3: "เตือนการนอนหลับ",
    setscope4: "อัตราหัวใจทารกในครรภ์",
    setscope5: "น้ำตาลในเลือดหลังงดอาหาร 8 ชั่วโมง",
    setscope6: "น้ำตาลในเลือดหลังทานอาหาร",
    setscope7: "เตือนออกซิเจนในเลือด",
    setscope8: "กรดยูริกในผู้ชาย",
    setscope9: "กรดยูริกในผู้หญิง",
    setscope10: "Systolic ",
    setscope11: "Diastolic ",
    setscope12: "สูง",
    setscope13: "ต่ำ",
    setscope14: "ตั้งค่าการแจ้งเตือน",
    setscope15: "ตั้งค่าสำเร็จ",
    setscope16: "มากเกินไป",
    setscope17: "น้อยเกินไป",
    setscope18: " เตือน",

    //下载页
    onload1: "คลิก",
    onload2: "เข่าวมกลุ่ม",
    onload3: "เปิดด้วยเว็บเบราว์เซอร์",
    onload4: "ยืนยัน",
    onload5: "มีความสุขกับสุขภาพได้ทุกวัน",
    onload6: "ดาวน์โหลดฟรีที่ App Store",
    onload7: "ดาวน์โหลดฟรีที่ Play Store",
    onload8: "ลิงค์หมดอายุ",
    onload9: "QR code หมดอายุ",
    onload10: "การเข้าร่วมสำเร็จ",

    // 待处理
    pending1: "ยอมรับ",
    pending2: "ปฏิเสธ",
    pending3: "ส่งการเชิญอีกครั้ง",
    pending4: "ไม่มีข้อมูล",
    pending5: "ส่งคำเชิญไปแล้ว กรุณารอสำหรับการยอมรับ",
    pending6: "ตกลง",
    pending7: "ออก",

    guide1: "กรุณาสร้างกลุ่มสุขภาพ พร้อมตั้งชื่อกลุ่ม",
    guide2:
      "คุณสามารถเช็คข้อมูลสุขภาพของสมาชิกในกลุ่ม และยังสามารถเชิญสมาชิกใหม่เข้ามาในกลุ่มนี้ได้",
    guide3:
      "You can invite new members via QR code scan, WeChat, mobile or email. Once the new member joins the group, you can check his/her health data.",
    guide4:
      "คุณสามารถเช็คประวัติของสมาชิกในกลุ่ม รวมทั้งข้อมูลที่ผิดผกติของแต่ละคน",
    guide5: "ถัดไป",
    guide6: "ตกลง",
    guide7: "เตือนค่าสูงผิดปกติ",

    invite1: "เข้าร่วมผ่าน เบอร์โทรศัพท์/อีเมล์",
    invite2: "กรอกชื่อบัญชี",
    invite3: "กรอกเบอร์โทรศัพท์",
    invite4: "กรอกอีเมล์",
    invite5: "กรอกเบอร์โทรศัพท์ที่ถูกต้อง",
    invite6: "กรอกอีเมล์ศัพท์ที่ถูกต้อง",
    invite7: "เข้าร่วมกลุ่มเรียบร้อยแล้ว",
    invite8: "ไม่พบชื่อบัญชีนี้",
    invite9: "โปรดเลือกประเทศ",
    invite10: "กรอกคำค้นหา",
    invite11: "ผู้ใช้",
    invite12: "เชิญ",
    invite13: "โปรดเลือก"
  }
};



// WEBPACK FOOTER //
// ./src/lang/th.js